/* global axios */
import ApiClient from '../ApiClient';

class LumerAITools extends ApiClient {
  constructor() {
    super('lumerai/assistants/tools', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, {
      params,
    });
  }
}

export default new LumerAITools();
